import api from "./api";
import axios from "axios";
import { ResponseInterface } from "../interfaces";
import { AgreementBUDTO } from "../interfaces/Dtos/AgreementBUDTO";

const baseURLAPI = process.env.REACT_APP_API_HOST;

export const getAgreementBUByAgreementID = async (
  agreementID: string
): Promise<ResponseInterface<AgreementBUDTO[]>> => {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  const uri = `${baseURLAPI}/Agreement/GetAgreementBUByAgreementID?AgreementID=${agreementID}`;

  try {
    const response = await api.get(uri, {
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken: source.token,
    });

    return response.data;
  } catch (error) {}

  return {
    model: null,
    didError: true,
    message: "",
    errorMessage: "",
  };
};
